import React, { Component } from 'react';
class TermsConditionInfo extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {

  }


  render() {
    return (
      <div className="container-xxl mt-5">
          <div className="container inner_con">

              <div className="row g-4 mb-5" id="corporate_capital_markets">
                  <h2 className="text-start mb-2 wow fadeInUp title_view" data-wow-delay="0.1s">TERMS OF USE</h2>
                  <div className="col-lg-12 wow fadeIn mt-2" data-wow-delay="0.5s">

                  <h4 className="mb-4"><spam className="card_title">BYLAWS Legal LLP website and tech Infra</spam></h4>
                  <p className="mb-3">A) These Terms of Use (“Terms”) govern access to and use of the website, digital platforms, online portals, systems, tools, software, applications,
                  communication channels, and any technology-enabled interface (collectively, “Platform”) owned, operated, or made available by BYLAWS Legal
                  LLP (“BYLAWS”, “the Firm”, “we”, “our”, or “us”).
                  </p>
                  <p className="mb-3">
                  By accessing, browsing, or using the Platform, you (“User”) acknowledge that you have read, understood, and agreed to be bound by these
                  Terms, along with the Privacy Policy and Disclaimer available on the Platform. If you do not agree, you must immediately discontinue use of the
                  Platform.
                  </p>
                  <p className="mb-3">
                  The Platform is provided strictly for general informational purposes and for limited administrative, communication, or internal use, where
                  expressly permitted. The Platform is not intended to provide full-time legal advice, create professional obligations or substitute for formal legal
                  engagement. The Platform may contain information relating to laws, regulations, judicial decisions, regulatory updates, publications, articles and
                  insights. Such information is generic in nature and may not reflect current legal developments. BYLAWS reserves the unrestricted right to modify,
                  suspend, restrict, or discontinue any part of the Platform at any time without notice.
                  </p>
                  <p className="mb-3">
                  By using the Platform, the User represents and warrants that:
                  </p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>They are legally competent to enter into binding terms</p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Their use is lawful and compliant with applicable laws</p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>They will not misuse the Platform for unlawful, abusive, misleading or unauthorised purposes</p>
                  <p className="mb-5 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>They will not upload, transmit, or introduce harmful code, malware, or unauthorised data</p>

                  <p className="mb-2">BYLAWS reserves the right to restrict or terminate access for any breach or suspected breach of these Terms.</p>
                  <p className="mb-2">Any communication transmitted to BYLAWS through the Platform or electronically prior to a formal engagement shall not be considered
                  confidential or privileged. Users must not transmit sensitive, confidential or privileged information unless expressly authorised in writing by
                  BYLAWS. BYLAWS disclaims liability for any loss of confidentiality, privilege, or legal protection arising from unsolicited or unauthorised
                  communications.</p>
                  <p className="mb-2">All content, design, layout, text, graphics, logos, images, software, code, and materials on the Platform are the exclusive intellectual property of
                   BYLAWS or its licensors, unless otherwise stated. Users are granted a limited, non-exclusive, non-transferable and revocable licence to access
                  the Platform for personal, non-commercial use only. Any unauthorised reproduction, modification, distribution, reverse engineering, scraping or
                  commercial exploitation is strictly prohibited and may result in legal action.</p>
                  <p className="mb-2">The Platform may incorporate or rely upon:</p>

                  <p className="mb-2 ms-3">1. Web hosting services</p>
                  <p className="mb-2 ms-3">2. Cloud infrastructure</p>
                  <p className="mb-2 ms-3">3. Communication tools</p>
                  <p className="mb-2 ms-3">4. Analytics and security tools</p>
                  <p className="mb-2 ms-3">5. Third-party software or APIs</p>

                  <p className="mb-2">BYLAWS does not guarantee uninterrupted, error-free, secure, or virus-free operation of the Platform. All use is at the User’s own risk. BYLAWS
                  disclaims liability for system outages or downtime, Cyber incidents or unauthorised access, Data corruption or loss and Third-party service
                  failures</p>
                  <p className="mb-2">Users shall not:</p>

                  <p className="mb-2 ms-3">1. Use the Platform for unlawful, misleading, or harmful purposes</p>
                  <p className="mb-2 ms-3">2. Attempt unauthorised access to systems or data</p>
                  <p className="mb-2 ms-3">3. Interfere with Platform security or integrity</p>
                  <p className="mb-2 ms-3">4. Upload defamatory, obscene, or infringing material</p>
                  <p className="mb-2 ms-3">5. Impersonate any person or entity</p>

                  <p className="mb-2">Any such conduct may result in immediate termination of access and legal action.
                  The Platform may contain links to third-party websites or services. BYLAWS does not control, endorse, or assume responsibility for third-party
                  content, availability, security, or practices. Access to third-party platforms is entirely at the User’s own risk.</p>


                  <p className="mb-2">B) Data Protection and Privacy</p>
                  <p className="mb-2">Use of the Platform is subject to the Firm’s Privacy Policy. BYLAWS processes personal data in accordance with applicable laws and
                  professional obligations but disclaims liability except where mandated by law.</p>

                  <p className="mb-2">The Platform is provided on an “as is” and “as available” basis. BYLAWS makes no warranties, express or implied, including warranties of
                  accuracy, reliability, merchantability, fitness for a particular purpose, or non-infringement.</p>

                  <p className="mb-2">To the maximum extent permitted by law, BYLAWS disclaims all liability arising from or in connection with:</p>

                  ● Use or inability to use the Platform or Reliance on content or for any Errors, omissions, or delays or due to Cyber or system failures
                  ● Indirect, consequential, incidental, or punitive damages
                  <p className="mb-2">Liability, if any, shall be limited strictly to the extent mandatorily imposed by law.</p>

                  <p className="mb-2">The User agrees to indemnify and hold harmless BYLAWS, its partners, employees, consultants and affiliates from any claims, losses, liabilities,
                  damages or expenses arising from:</p>

                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Breach of these Terms</p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Misuse of the Platform</p>
                  <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Violation of applicable laws</p>

                  <p className="mb-2">BYLAWS may suspend or terminate access to the Platform at any time, without notice, for any reason, including suspected breach or security
                  concerns.</p>
                  <p className="mb-2">BYLAWS reserves the right to modify these Terms at any time. Continued use of the Platform constitutes acceptance of the amended Terms.
                  These Terms shall be governed by the laws of India. Courts having jurisdiction over the Firm’s principal office shall have exclusive jurisdiction. If
                  any provision is held invalid, the remaining provisions shall remain in full force. Failure to enforce any provision shall not constitute a waiver. All
                  risks associated with access to, use of or reliance upon the Platform rest solely with the User. BYLAWS shall bear liability only where such
                  liability cannot be lawfully excluded.</p>



                  </div>
                </div>
                </div>
            </div>
    );
  }
}

export default TermsConditionInfo;
